import React from "react";
import {Spinner} from "evergreen-ui";

const Loader = (props) => {

    const {
        type,
        top,
        bottom,
    } = props;

    let style;
    if (type === 1) {
        style = {
            "position": "fixed",
            "width": "100%",
            "background": "rgba(255, 255, 255, 0.8)",
            "top": top || 0,
            "bottom": bottom || 0,
            "height": "100vh"
        }
    }

    return (
        <div className={"loader-container"} style={{...style}}>
            <Spinner/>
        </div>
    )
};

export default Loader
